// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 1: LA GENESI
// ============================================================================
// Livelli 1-13 (13 livelli, 39 domande)

export const chapter1Translations = {
  name: "La Genesi",
  description: "In principio... La conoscenza vivifica lo spirito",
  
  spiritualWisdom: {
    principle: "La conoscenza vivifica lo spirito",
    scripture: "Il mio popolo perisce per mancanza di conoscenza (Osea 4:6)",
    application: "Ogni versetto studiato, ogni verità scoperta nutre la nostra anima e fortifica la nostra fede"
  },
  
  levels: {
    1: {
      name: "La Creazione",
      challenge: "In principio Dio creò i cieli e la terra...",
      easy: {
        question: "In quanti giorni Dio creò il mondo?",
        options: ["5 giorni", "6 giorni", "7 giorni", "8 giorni"],
        hint: "Pensa al giorno di riposo della settimana",
        funFact: "💡 Il settimo giorno, Dio si riposò. È l'origine del Sabato, giorno di riposo settimanale!"
      },
      medium: {
        question: "Cosa creò Dio il quarto giorno?",
        options: ["Gli animali", "L'uomo", "Il sole, la luna e le stelle", "Le piante"],
        hint: "Queste creazioni illuminano la terra e segnano il tempo",
        funFact: "🌟 Le luci furono create per segnare le stagioni e le feste religiose!"
      },
      hard: {
        question: "Cosa significa che l'uomo fu creato 'a immagine di Dio'?",
        options: [
          "Aspetto fisico identico",
          "Capacità di creare e amare",
          "Immortalità naturale",
          "Potere divino"
        ],
        hint: "Si tratta di qualità spirituali e intellettuali",
        funFact: "✨ L'immagine di Dio in noi include creatività, coscienza morale e capacità di amare!"
      }
    },
    
    2: {
      name: "La Tentazione del Giardino",
      challenge: "Il serpente era il più astuto di tutti gli animali dei campi...",
      easy: {
        question: "Quale animale tentò Eva nel giardino?",
        options: ["Il leone", "Il serpente", "L'aquila", "Il drago"],
        hint: "Questo animale striscia sul ventre",
        funFact: "🐍 Il serpente rappresenta la tentazione e l'astuzia in tutta la Bibbia!"
      },
      medium: {
        question: "Quale promessa menzognera fece il serpente a Eva?",
        options: [
          "Sarete immortali",
          "Sarete ricchi",
          "Sarete come dèi",
          "Sarete felici"
        ],
        hint: "Il serpente promette elevazione al livello divino",
        funFact: "🎭 La menzogna del serpente mescola verità e inganno - tecnica di tentazione classica!"
      },
      hard: {
        question: "Come questa caduta illumina la nostra lotta tra bene e male?",
        options: [
          "Il male è più forte",
          "Il libero arbitrio implica responsabilità",
          "Dio ci abbandona",
          "La tentazione è invincibile"
        ],
        hint: "Si tratta della nostra capacità di scegliere e assumerne le conseguenze",
        funFact: "🌳 L'albero della conoscenza simboleggia la scelta morale che definisce l'umanità!"
      }
    },
    
    3: {
      name: "Caino e Abele",
      challenge: "Due fratelli, due offerte, un dramma eterno...",
      easy: {
        question: "Chi fu il primo omicida della storia biblica?",
        options: ["Abele", "Set", "Caino", "Adamo"],
        hint: "Il fratello geloso di Abele",
        funFact: "⚡ Caino diventa il simbolo della gelosia fraterna distruttiva!"
      },
      medium: {
        question: "Perché Dio preferì l'offerta di Abele?",
        options: [
          "Quantità maggiore",
          "Abele era più bello",
          "Offerta con cuore sincero",
          "Era carne"
        ],
        hint: "Dio guarda al cuore",
        funFact: "❤️ Dio guarda al cuore, non solo all'apparenza delle nostre azioni!"
      },
      hard: {
        question: "Cosa ci insegna questa storia sulla gelosia?",
        options: [
          "La gelosia è naturale",
          "La gelosia non controllata porta alla distruzione",
          "Dio favorisce alcuni",
          "La competizione è sana"
        ],
        hint: "Si tratta delle conseguenze di non controllare le nostre emozioni",
        funFact: "🔥 'Il peccato sta spiandoti alla porta' - Dio ci avverte prima della caduta!"
      }
    },

    4: {
      name: "Il Diluvio di Noè",
      challenge: "E piovve sulla terra quaranta giorni e quaranta notti...",
      easy: {
        question: "Quanti giorni e notti durò la pioggia del diluvio?",
        options: ["30 giorni", "40 giorni", "50 giorni", "100 giorni"],
        hint: "Un numero simbolico nella Bibbia",
        funFact: "☔ Il numero 40 simboleggia la prova e la trasformazione nella Bibbia!"
      },
      medium: {
        question: "Quanti animali puri doveva prendere Noè nell'arca?",
        options: [
          "1 coppia",
          "2 coppie",
          "7 coppie",
          "10 coppie"
        ],
        hint: "Più degli animali impuri",
        funFact: "🦁 Gli animali puri erano destinati ai sacrifici dopo il diluvio!"
      },
      hard: {
        question: "Cosa simboleggia l'arca nel nostro percorso spirituale?",
        options: [
          "La fuga dai problemi",
          "La salvezza mediante fede e obbedienza",
          "L'isolamento necessario",
          "La superiorità dei credenti"
        ],
        hint: "Si tratta della salvezza offerta a chi crede",
        funFact: "🚢 L'arca prefigura la salvezza: una sola via per sfuggire al giudizio!"
      }
    },

    5: {
      name: "La Torre di Babele",
      challenge: "Costruiamoci una torre la cui cima giunga fino al cielo...",
      easy: {
        question: "Cosa confuse Dio a Babele?",
        options: ["I piani", "Le lingue", "Gli strumenti", "I pensieri"],
        hint: "Ciò che permette di comunicare",
        funFact: "🗣️ Babele è l'origine mitica della diversità linguistica mondiale!"
      },
      medium: {
        question: "Perché gli uomini volevano costruire questa torre?",
        options: [
          "Per proteggersi",
          "Per vivere insieme",
          "Per farsi un nome e raggiungere il cielo",
          "Per onorare Dio"
        ],
        hint: "Si tratta di orgoglio e voler eguagliare Dio",
        funFact: "🏗️ L'orgoglio di voler eguagliare Dio porta sempre alla confusione!"
      },
      hard: {
        question: "Come si manifesta oggi l'orgoglio di Babele?",
        options: [
          "Solo nella tecnologia",
          "Nella volontà umana di autonomia assoluta senza Dio",
          "Nei grattacieli",
          "Nelle lingue diverse"
        ],
        hint: "Si tratta di voler fare a meno di Dio",
        funFact: "💭 Babele ci ricorda che l'unità senza Dio diventa orgoglio distruttivo!"
      }
    },

    6: {
      name: "La Chiamata di Abramo",
      challenge: "Vattene dal tuo paese, dalla tua patria e dalla casa di tuo padre...",
      easy: {
        question: "Quanti anni aveva Abramo quando lasciò il suo paese?",
        options: ["50 anni", "65 anni", "75 anni", "100 anni"],
        hint: "Un'età molto avanzata per ricominciare tutto",
        funFact: "🚶 A 75 anni, Abramo inizia una nuova vita - non è mai troppo tardi!"
      },
      medium: {
        question: "Quale triplice promessa fece Dio ad Abramo?",
        options: [
          "Ricchezza, potere, saggezza",
          "Terra, discendenza, benedizione universale",
          "Lunga vita, pace, prosperità",
          "Fede, speranza, amore"
        ],
        hint: "Una promessa che riguarda tutta l'umanità",
        funFact: "🌟 La promessa ad Abramo riguarda tutta l'umanità, non solo lui!"
      },
      hard: {
        question: "Cosa ci insegna il 'salto di fede' di Abramo?",
        options: [
          "La fede cieca è pericolosa",
          "Seguire Dio richiede di lasciare le nostre sicurezze",
          "Dio favorisce certi popoli",
          "La fede garantisce il successo"
        ],
        hint: "Si tratta di fidarsi abbandonando i nostri punti di riferimento",
        funFact: "✨ Abramo è chiamato 'padre della fede' perché credette senza vedere!"
      }
    },

    7: {
      name: "Il Sacrificio di Isacco",
      challenge: "Prendi tuo figlio, il tuo unico, colui che ami...",
      easy: {
        question: "Su quale monte Abramo doveva sacrificare Isacco?",
        options: ["Sinai", "Moriah", "Carmelo", "Sion"],
        hint: "Questo monte diventerà un luogo sacro",
        funFact: "🏔️ Il monte Moriah diventerà il luogo del Tempio di Gerusalemme!"
      },
      medium: {
        question: "Cosa provvide Dio al posto di Isacco?",
        options: [
          "Un agnello",
          "Un montone impigliato per le corna",
          "Una capra",
          "Un toro"
        ],
        hint: "Un animale maschio adulto con corna",
        funFact: "🐏 Il montone sostitutivo prefigura il sacrificio sostitutivo ultimo!"
      },
      hard: {
        question: "Come questa prova illustra la fede assoluta?",
        options: [
          "Dio mette alla prova crudelmente",
          "La fede trascende persino l'amore paterno",
          "I sacrifici umani piacciono a Dio",
          "Abramo non amava veramente Isacco"
        ],
        hint: "Si tratta di fidarsi anche quando non capiamo",
        funFact: "💝 Dio provvede sempre una via d'uscita quando confidiamo in Lui!"
      }
    },

    8: {
      name: "Giacobbe ed Esaù",
      challenge: "Il maggiore servirà il minore...",
      easy: {
        question: "Per cosa vendette Esaù la sua primogenitura?",
        options: ["Oro", "Un piatto di lenticchie", "Vestiti", "Vino"],
        hint: "Un piatto per saziare la sua fame",
        funFact: "🍲 Un momento di fame costò a Esaù la sua benedizione eterna!"
      },
      medium: {
        question: "Come ingannò Giacobbe suo padre Isacco?",
        options: [
          "Cambiando voce",
          "Travestendosi",
          "Coprendosi con pelle di capra",
          "Mentendo sul suo nome"
        ],
        hint: "Per assomigliare al fratello peloso",
        funFact: "🎭 Isacco, cieco, riconobbe l'odore e il tatto ma non l'inganno!"
      },
      hard: {
        question: "Cosa rivela questa storia sulle nostre scelte?",
        options: [
          "L'inganno è a volte necessario",
          "I desideri immediati possono costarci il nostro destino",
          "Dio approva l'astuzia",
          "Il minore è sempre favorito"
        ],
        hint: "Si tratta delle conseguenze delle nostre decisioni impulsive",
        funFact: "⚖️ Le nostre scelte impulsive possono avere conseguenze eterne!"
      }
    },

    9: {
      name: "Il Sogno di Giacobbe",
      challenge: "Vide una scala poggiata sulla terra, la cui cima toccava il cielo...",
      easy: {
        question: "Cosa vide Giacobbe nel suo sogno?",
        options: [
          "Un albero gigante",
          "Una scala verso il cielo con angeli",
          "Un tempio",
          "Stelle"
        ],
        hint: "Un mezzo di comunicazione tra cielo e terra",
        funFact: "👼 La scala di Giacobbe simboleggia il legame tra Cielo e Terra!"
      },
      medium: {
        question: "Cosa fece Giacobbe con la pietra che gli serviva da cuscino?",
        options: [
          "La ruppe",
          "La seppellì",
          "La eresse e la unse con olio",
          "La portò con sé"
        ],
        hint: "Ne fece un monumento sacro",
        funFact: "🪨 Questa pietra diventa 'Betel' - la casa di Dio!"
      },
      hard: {
        question: "Come connette questa visione cielo e terra nella nostra vita?",
        options: [
          "Solo attraverso i sogni",
          "Attraverso la preghiera che stabilisce il ponte con il divino",
          "Attraverso gli angeli custodi",
          "Attraverso i luoghi sacri"
        ],
        hint: "Si tratta della nostra comunicazione con Dio",
        funFact: "🌉 La preghiera è la nostra scala personale verso il Cielo!"
      }
    },

    10: {
      name: "Giuseppe Venduto dai Fratelli",
      challenge: "Ecco arrivare il sognatore...",
      easy: {
        question: "Quanti fratelli aveva Giuseppe?",
        options: ["7 fratelli", "10 fratelli", "11 fratelli", "12 fratelli"],
        hint: "Uno in meno del numero delle tribù d'Israele",
        funFact: "👨‍👨‍👦‍👦 I 12 figli di Giacobbe diventeranno le 12 tribù d'Israele!"
      },
      medium: {
        question: "Per quanti pezzi d'argento fu venduto Giuseppe?",
        options: [
          "10 pezzi",
          "20 pezzi",
          "30 pezzi",
          "50 pezzi"
        ],
        hint: "Il prezzo di uno schiavo",
        funFact: "💰 20 pezzi d'argento, il prezzo di uno schiavo in quell'epoca!"
      },
      hard: {
        question: "Come si trasforma la gelosia in strumento del piano divino?",
        options: [
          "Dio approva la gelosia",
          "Il male commesso è trasformato in bene da Dio",
          "La gelosia è necessaria",
          "I fratelli avevano ragione"
        ],
        hint: "Si tratta della provvidenza divina che trasforma il male",
        funFact: "🎨 Dio trasforma anche le nostre peggiori azioni in capolavoro di grazia!"
      }
    },

    11: {
      name: "Giuseppe in Prigione",
      challenge: "Il Signore era con Giuseppe e stese su di lui la sua misericordia...",
      easy: {
        question: "Quale dono speciale aveva Giuseppe?",
        options: [
          "Profetizzare",
          "Interpretare i sogni",
          "Guarire i malati",
          "Parlare con gli animali"
        ],
        hint: "Una capacità legata ai sogni",
        funFact: "💭 I sogni erano considerati messaggi divini nell'antichità!"
      },
      medium: {
        question: "Quali servi del Faraone erano in prigione con Giuseppe?",
        options: [
          "Il visir e lo scriba",
          "Il coppiere e il panettiere",
          "Il medico e la guardia",
          "Il cuoco e il giardiniere"
        ],
        hint: "Colui che serviva il vino e colui che serviva il pane",
        funFact: "🍷 Il coppiere assaggiava il vino del re per evitare avvelenamenti!"
      },
      hard: {
        question: "Cosa ci insegna Giuseppe sulla fedeltà nell'avversità?",
        options: [
          "L'ingiustizia è accettabile",
          "La fedeltà a Dio trascende le circostanze",
          "La prigione cambia le persone",
          "Bisogna vendicarsi"
        ],
        hint: "Si tratta di rimanere fedeli anche nelle prove",
        funFact: "⭐ Anche in prigione, Giuseppe rimase integro e Dio lo elevò!"
      }
    },

    12: {
      name: "I Sogni del Faraone",
      challenge: "Sette vacche grasse... sette vacche magre...",
      easy: {
        question: "Quante vacche magre divorarono le vacche grasse?",
        options: ["5", "6", "7", "8"],
        hint: "Un numero perfetto",
        funFact: "🐄 Il numero 7 simboleggia la perfezione e la pienezza nella Bibbia!"
      },
      medium: {
        question: "Cosa significavano i 7 anni nel sogno?",
        options: [
          "7 anni di guerra poi pace",
          "7 anni di abbondanza poi 7 anni di carestia",
          "7 anni di malattia poi salute",
          "7 anni di pioggia poi siccità"
        ],
        hint: "Ciclo di abbondanza e scarsità",
        funFact: "🌾 Giuseppe salvò l'Egitto e la sua famiglia grazie a questa interpretazione!"
      },
      hard: {
        question: "Come trasforma la saggezza divina le crisi?",
        options: [
          "Evitando ogni crisi",
          "Dando previsione per prepararsi",
          "Punendo i malvagi",
          "Arricchendo i credenti"
        ],
        hint: "Si tratta di preparazione e anticipazione",
        funFact: "💡 La saggezza divina trasforma le crisi in opportunità di salvezza!"
      }
    },

    13: {
      name: "La Riconciliazione dei Fratelli",
      challenge: "Io sono Giuseppe, vostro fratello, che voi vendeste...",
      easy: {
        question: "Cosa mise Giuseppe nel sacco di Beniamino?",
        options: [
          "Oro",
          "Il suo anello",
          "La sua coppa d'argento",
          "Una lettera"
        ],
        hint: "Un oggetto personale prezioso",
        funFact: "🏆 La coppa serviva anche per 'leggere' il futuro nell'acqua!"
      },
      medium: {
        question: "Quale frase celebre disse Giuseppe sul male trasformato?",
        options: [
          "Vi perdono",
          "Voi pensaste del male contro di me, ma Dio lo ha volto in bene",
          "Dimentichiamo il passato",
          "La vendetta è di Dio"
        ],
        hint: "Una frase sulla provvidenza divina",
        funFact: "✨ Questa frase riassume tutta la provvidenza divina nelle nostre vite!"
      },
      hard: {
        question: "Come rompe il perdono i cicli di vendetta?",
        options: [
          "Dimenticando il male",
          "Liberando l'offensore e l'offeso per un nuovo inizio",
          "Punendo prima",
          "Mantenendo le distanze"
        ],
        hint: "Si tratta di liberazione reciproca",
        funFact: "🕊️ Il perdono di Giuseppe prefigura il perdono divino universale!"
      }
    }
  }
};

export default chapter1Translations;
